import { Component, Input } from 'ng-metadata/core';
import * as angular from 'angular';
import './source.scss';
import { MediaContactSource } from '../media-contact-document.model';

/**
 * @ngdoc directive
 * @name mwMediaContactDocumentSource
 * @module mw.components.contentDocuments
 *
 * @param {string} [url] - Base URL to be used to be used with source contact url.
 * @param {object} [source] - The content document.
 *
 * @description
 * `<mw-media-contact-document-source>` is a component used to the source of the influencer
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-media-contact-document-source
 *       url="::$ctrl.url"
 *      source="::$ctrl.contact.primarySource">
 *   </mw-media-contact-document-source>
 * </hljs>
 *
 */
const template = `
    <a  class="mw-media-contact-document-source"
        ng-href="{{::($ctrl.url + $ctrl.source.contactUrl)}}"
        ng-bind-html="::$ctrl.source.name">
    </a>
`;


@Component({
    selector: 'mw-media-contact-document-source',
    template: template
})

export class MediaContactDocumentSourceComponent {
    @Input('<') url: string;
    @Input('<') source: MediaContactSource;

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/source/source.component.ts